<template>
  <div class="workItem" @click.stop="jumpToWorkDetail()" ref="scratchWorkItem">
    <!-- <div class="img" :style="{ backgroundImage: `url(${getImg(dic.images)})`, height:`${work_img_height}px`}"></div> -->
    <div
      class="img"
      :style="{ backgroundImage: `url(${dic.images})`, height:`${work_img_height}px`}"
    ></div>
    <div class="text">
      <span class="title">{{ dic.name }}</span>
      <div class="icons line">
        <span class="zan" @click.stop="likeWorkEvent()">
          <img :src=" `${dic.islike ? images.like_select : images.like_unselect}`" />
          <span class="number">{{ dic.likes }}</span>
        </span>
        <span class="zan browser">
          <img :src="images.eye" />
          <span class="number">{{ dic.browser_count }}</span>
        </span>
      </div>
    </div>
  </div>
</template>



<script>
// @ is an alias to /src
import {
  IMG_WORK__LIKE_SELECT,
  IMG_WORK__LIKE_UNSELECT,
  IMG_EYE
} from "@/assets";
import { Utils } from "@/utils";

import { types as LoginTypes } from "@/store/modules/login";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ScratchWorkItem",
  components: {},
  props: {
    dic: {
      type: Object
    },
    dataType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      images: {
        like_select: IMG_WORK__LIKE_SELECT,
        like_unselect: IMG_WORK__LIKE_UNSELECT,
        eye: IMG_EYE
      },
      work_img_height: 230.5
    };
  },

  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS
    }),

    ...Utils,
    // 点赞作品
    likeWorkEvent() {
      let callback = () => {
        if (this.$parent.likeWorkEvent) {
          // <A><B><C></C></B></A>
          // 加入当前组件是 C，那么this.$parent则访问的是 A中的方法等，要想访问 B中的方法，推荐使用 emit;
          // 具体用法看 Works.vue 和 Home.vue
          this.$parent.likeWorkEvent(this.dic, this.dataType);
        } else {
          this.$emit("likeWorkEvent", this.dic, this.dataType);
        }
      };
      this.dependLoginStatus().then(callback);
    },
    //作品详情页
    jumpToWorkDetail() {
      if (this.$parent.jumpToWorkDetail) {
        this.$parent.jumpToWorkDetail(this.dic, this.dataType);
      } else {
        this.$emit("jumpToWorkDetail", this.dic, this.dataType);
      }
    }
  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.workItem {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .img {
    width: 100%;
    height: 150px;
    background-color: #e1e1e1;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 3px;
  }
  .text {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
    .title {
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      overflow-x: hidden;
      height: 20px;
      margin-top: 10px;
      flex: 1;
      white-space: nowrap;
      width: 100%;
      // text-overflow:ellipsis;
    }

    .icons {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: -10px;
      margin-left: -10px;
      padding-left: 10px;
      margin-right: -10px;
      padding-right: 10px;
      &.line {
        margin-top: 5px;
        padding-bottom: 5px;
        margin-bottom: 5px;
      }
      .zan {
        font-size: 13px;
        color: #999999;
        display: flex;
        flex-direction: row;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
        align-items: center;
        cursor: pointer;
        &.browser {
          margin-left: 20px;
        }
        img {
          height: 12px;
          margin-right: 3px;
        }
        .number {
          line-height: 20px;
          overflow: hidden;
          height: 20px;
        }
      }
    }
  }
}
</style>
